<template>
  <div class="col-12">
    <table class="table table-bordered bg-white table-sm" v-if="item">
      <tbody>
        <tr>
          <td>
            {{ $t("Protocolo") }}: <b>{{ item.protocolo }}</b>
          </td>
          <td>
            Criado: <b>{{ item.cadastrado }}</b>
          </td>
          <td>
            Atualizado: <b>{{ item.atualizado }}</b>
          </td>
        </tr>
        <tr>
          <td>
            Técnico responsável: 
            <b v-if="item.responsavel">{{ item.responsavel.nome }}</b> - <span> {{ item.responsavel.tecnico.profissao ?? 'Não informado' }} </span>
          </td>
          <td>
            Unidade:
            <b v-if="item.unidade">{{ item.unidade.nome }}</b>
          </td>
          <td>
            Status:
            <b v-if="item.unidade" v-html="item.status_nome"></b>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ["item"],
};
</script>
